<template>
  <FimButton
    type="secondary"
    class="h-10 w-full"
    :class="{ 'pointer-events-none invisible': isDisabled }"
    :disabled="isDisabled"
    size="sm"
    data-testid="product-list-vto-button"
    @click="handleOpenVTO"
  >
    <template #icon>
      <LazyIconFielmannWebcam class="size-6" />
    </template>
    {{ $t('vto.button_label') }}
  </FimButton>
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'

interface Props {
  product: Product
  variant?: Variant
  disabled?: boolean
}

const props = defineProps<Props>()

const { openVTO } = usePlpVTO()
const { trackVTOFittingBoxOpen } = await useTrackingEvents()

const isDisabled = ref(true)

watch(
  () => props.disabled,
  (value) => {
    isDisabled.value = value
  },
)

onMounted(() => {
  isDisabled.value = props.disabled
})

const handleOpenVTO = (event: Event) => {
  if (props.variant) {
    trackVTOFittingBoxOpen({
      productDetails: props.product,
      variant: props.variant,
      element: event?.target as HTMLButtonElement,
    })
  }
  openVTO(props.product, props.variant)
}
</script>
